import { IsEnum, IsNotEmpty, IsOptional } from 'class-validator';

import { DeliveryTypeEnum } from '@onArte/shared/database/enums';

export class CartAuctionUpdateFinishModel {
  @IsEnum(DeliveryTypeEnum)
  public deliveryType?: DeliveryTypeEnum;

  @IsNotEmpty()
  public deliveryAddressId?: string;

  @IsNotEmpty()
  public billingAddressId?: string;

  @IsNotEmpty()
  public invoiceRequired?: boolean;

  @IsOptional()
  public commentToSeller?: string;

  constructor(
    deliveryType?: DeliveryTypeEnum,
    deliveryAddressId?: string,
    billingAddressId?: string,
    invoiceRequired?: boolean,
    commentToSeller?: string
  ) {
    this.deliveryType = deliveryType;
    this.deliveryAddressId = deliveryAddressId;
    this.billingAddressId = billingAddressId;
    this.invoiceRequired = invoiceRequired;
    this.commentToSeller = commentToSeller;
  }
}
